import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/mortgage/scale/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/mortgage/scale/add',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/mortgage/scale/update',
      data,
      dataType: 'form'
    });
  },
  remove(data) {
    return http.post({
      url: '/la/admin/mortgage/scale/delete',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  createCycle(data) {
    return http.post({
      url: '/la/admin/mortgage/rate/add',
      data,
      dataType: 'form'
    });
  },
  getCycleList(data) {
    return http.get({
      url: '/la/admin/mortgage/rate/list',
      data
    });
  },
  removeCycle(data) {
    return http.post({
      url: '/la/admin/mortgage/rate/delete',
      data,
      dataType: 'form'
    });
  }
};
